import { render } from "./NewDonorDeclarationForm.vue?vue&type=template&id=66144a95&scoped=true"
import script from "./NewDonorDeclarationForm.vue?vue&type=script&lang=js"
export * from "./NewDonorDeclarationForm.vue?vue&type=script&lang=js"

import "./NewDonorDeclarationForm.vue?vue&type=style&index=0&id=66144a95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66144a95"]])

export default __exports__